

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {

        const { FairUseAlertWidget, DisableWidgetFairUseWrapper, FairUseReminderAlertWidget } = await import('@open-craft/frontend-slot-fair-use');

        
      addPlugins(config, 'course_outline_page_alerts_slot', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'fair-use-alert-widget',
        type: DIRECT_PLUGIN,
        priority: 1,
        RenderWidget: FairUseAlertWidget,
      },
    },
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'fair-use-reminder-widget',
        type: DIRECT_PLUGIN,
        priority: 1,
        RenderWidget: FairUseReminderAlertWidget,
      },
    },

]);
      addPlugins(config, 'edit_file_error_alerts_slot', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'fair-use-alert-widget',
        type: DIRECT_PLUGIN,
        priority: 1,
        RenderWidget: FairUseAlertWidget,
      },
    },
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'fair-use-reminder-widget',
        type: DIRECT_PLUGIN,
        priority: 1,
        RenderWidget: FairUseReminderAlertWidget,
      },
    },

]);
      addPlugins(config, 'files_upload_page_table_slot', [
    {
      op: PLUGIN_OPERATIONS.Wrap,
      widgetId: 'default_contents',
      wrapper: DisableWidgetFairUseWrapper,
    }
]);
      addPlugins(config, 'videos_upload_page_table_slot', [
    {
      op: PLUGIN_OPERATIONS.Wrap,
      widgetId: 'default_contents',
      wrapper: DisableWidgetFairUseWrapper,
    }
]);
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
  } catch { }

  return config;
}

export default setConfig;